import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';
import { Parallax } from 'react-scroll-parallax';
import './style.css';
import image1 from '../../../../assets/images/texture-4.jpg';
import image2 from '../../../../assets/images/texture-5.jpg';

export default class Hero extends Component {
  render() {
    return (
      <div className="hero-container relative ma0 pa0">
        <Fade duration={1000}>
        <h1 className="hero-title absolute z-3">
          Never die without leaving a scratch.
        </h1>
        </Fade>
        <div className="absolute button-scroll-down pointer z-3" onClick={() => {window.scrollTo(0,document.body.scrollHeight);}}>
          <div className="absolute button-scroll-down-decoration">
          </div>
          <div className="absolute button-scroll-down-title">
          contact me
          </div>
        </div>
        <Parallax className="pattern-1 overflow-hidden absolute z-1 ma0 pa0" offsetYMax={10} offsetYMin={-10}>
          <Parallax className="overflow-hidden w-100" offsetYMax={20} offsetYMin={-20} slowerScrollRatetag="figure">
              <picture className="w-100">
                <source data-srcset={image1} type="image/jpg" srcSet={image1}></source>
                <img className="w-100" data-src={image1} src={image1} alt="something about you"></img>
              </picture>
          </Parallax>
        </Parallax>
        <Parallax className="pattern-2 overflow-hidden absolute z-1 ma0 pa0" offsetYMax={10} offsetYMin={-10}>
          <Parallax className="mask w-100" offsetYMax={20} offsetYMin={-20} slowerScrollRatetag="figure">
              <picture className="w-100">
                <source data-srcset={image2} type="image/jpg" srcSet={image2}></source>
                <img className="w-100" data-src={image2} src={image2} alt="makes me feel like"></img>
              </picture>
          </Parallax>
        </Parallax>
        <figure className="blank-pattern-1 z-0 absolute ma0 pa0"></figure>
        <figure className="blank-pattern-2 z-2 absolute ma0 pa0"></figure>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home/Sections/Hero/index.jsx